<template>
  <div class="tag-discount rounded-circle d-flex flex-column align-items-center justify-content-center">
    <div>SAVE</div>
    <div>{{ discount }}%</div>
  </div>
</template>

<script>
export default {
  name: 'TagDiscount',
  props: {
    discount: {
      type: Number,
      default: null
    }
  }
}
</script>

<style scoped>
.tag-discount {
  width: 48px;
  height: 48px;
  background-color: var(--loft-color);
  color: white;
  font-size: 14px;
  font-family: 'Noto Serif TC', serif;
  font-weight: 700;
  line-height: 1;
}
</style>
